import React from 'react';
import PureComponent from 'components/PureComponent';

import vk from 'raw!svgo?useConfig=svgoConfig!./vk._svg';
// import fb from 'raw!svgo?useConfig=svgoConfig!./fb._svg';
// import insta from 'raw!svgo?useConfig=svgoConfig!./insta._svg';

class Share extends PureComponent {

	render() {
		require('./Share.styl');

		return (
			<div className="Share">
				<ul className="Share__socs">
					<li className="Share__soc">
						<a href="#" className="Share__link Share__link--vk" dangerouslySetInnerHTML={{__html: vk}} />
					</li>
					{/* <li className="Share__soc">
						<a href="#" className="Share__link Share__link--fb" dangerouslySetInnerHTML={{__html: fb}} />
					</li>
					<li className="Share__soc">
						<a href="#" className="Share__link Share__link--insta" dangerouslySetInnerHTML={{__html: insta}} />
					</li> */}
				</ul>
			</div>
		);
	}

}

export default Share;



// WEBPACK FOOTER //
// ./src/components/Share/Share.js